import React, { useEffect, useState } from 'react';
import {
  Box,
  HeadingText,
  GDSStyleObject,
  StackLayout,
  ParagraphText,
  Radio,
  Fieldset,
  FormField,
  TextInput,
  Select,
} from '@leagueplatform/genesis-core';
import { IS_POLICY_HOLDER_PATIENT } from '../../../../../types/online-forms.types';
import { isEmpty, isNotEmpty, updateFormData } from '../../../helpers';

export function PatientInformation(props: any) {
  const {
    errorHandling,
    nextButtonClicked,
    profileResponseData,
    isValidateForm,
    footerToBottom,
  } = props;

  const [policyHolderRelationship] = useState(
    profileResponseData?.demographics?.relationship,
  );
  const [isPolicyHolderPatient, setIsPolicyHolderPatient] = useState('');
  const [form, setForm] = useState({
    isPolicyHolderPatient: '',
    patientRelationship: '',
    patientName: '',
    patientDateOfBirth: '',
  });
  const [planDetailsData, setPlanDetailsData] = useState<any[]>([]);
  const [isPolicyHolderError, setIsPolicyHolderError] = useState(false);

  useEffect(() => {
    footerToBottom(false);
  }, [footerToBottom]);

  const [errors, setErrors] = useState({
    patientRelationship: false,
    patientName: false,
    patientDateOfBirth: false,
  });

  const formField =
    isEmpty(form.patientRelationship) ||
    isEmpty(form.patientName) ||
    isEmpty(form.patientDateOfBirth);

  const isValid =
    isNotEmpty(form.patientRelationship) &&
    isNotEmpty(form.patientName) &&
    isNotEmpty(form.patientDateOfBirth);

  useEffect(() => {
    if (isPolicyHolderPatient === 'YES') {
      errorHandling(true);
    } else if (isPolicyHolderPatient === '') {
      errorHandling(false);
    } else if (formField) {
      errorHandling(false);
    } else {
      errorHandling(true);
    }
  }, [formField, errorHandling, form, isPolicyHolderPatient]);

  useEffect(() => {
    if (nextButtonClicked) {
      if (!isValid) {
        setErrors({
          patientRelationship: isEmpty(form.patientRelationship),
          patientName: isEmpty(form.patientName),
          patientDateOfBirth: isEmpty(form.patientDateOfBirth),
        });
        setIsPolicyHolderError(isEmpty(isPolicyHolderPatient));
      }
    }
  }, [nextButtonClicked, isValid, form, isPolicyHolderPatient]);

  useEffect(() => {
    const pInfo = JSON.parse(sessionStorage.getItem('formData') || '{}');
    if (pInfo) {
      setForm({
        isPolicyHolderPatient: pInfo?.isPolicyHolderPatient,
        patientRelationship: pInfo?.patientRelationship,
        patientName: pInfo?.patientName,
        patientDateOfBirth: pInfo?.patientDateOfBirth,
      });
    }
    setPlanDetailsData(pInfo?.dependents);
    setIsPolicyHolderPatient(pInfo?.isPolicyHolderPatient);
  }, []);

  const updateErrorState = (value: string, id: string) => {
    if (id === 'isPolicyHolderPatient-1' || id === 'isPolicyHolderPatient-2') {
      setErrors((prevState) => ({
        ...prevState,
        patientRelationship: false,
        patientName: false,
        patientDateOfBirth: false,
      }));
    } else if (id === 'patientName') {
      setErrors((prevState) => ({
        ...prevState,
        [id]: isEmpty(value),
        patientDateOfBirth: false,
      }));
    } else {
      const nextErrorState = {
        ...errors,
        [id]: isEmpty(value),
      };
      setErrors(nextErrorState);
    }
  };

  const onUpdateField = (event: any) => {
    const { value, id } = event.target;
    if (id === 'patientRelationship') {
      const newFormState = {
        ...form,
        [id]: value,
        patientName: '',
        patientDateOfBirth: '',
      };
      setForm(newFormState);
    } else if (id === 'patientName') {
      if (value) {
        const dob = planDetailsData
          .filter((patient: any) => patient.name === value)
          .map((patient: any) => patient.dateOfBirth)[0];
        const newFormState = {
          ...form,
          [id]: value,
          patientDateOfBirth: dob,
        };
        setForm(newFormState);
      } else {
        const newFormState = {
          ...form,
          [id]: value,
          patientDateOfBirth: '',
        };
        setForm(newFormState);
      }
    } else {
      const nextFormState = {
        ...form,
        [id]: value,
      };
      setForm(nextFormState);
    }
    updateErrorState(value, id);
  };

  const updateIsPolicyHolderPatient = (e: any) => {
    const { value, id } = e.target;
    if (value === 'Yes') {
      setIsPolicyHolderPatient('YES');
      setIsPolicyHolderError(false);
      const nextFormState = {
        isPolicyHolderPatient: 'YES',
        patientRelationship: '',
        patientName: '',
        patientDateOfBirth: '',
      };
      isValidateForm(true);
      setForm(nextFormState);
    } else {
      setIsPolicyHolderPatient('NO');
      setIsPolicyHolderError(false);
      const nextFormState = {
        isPolicyHolderPatient: 'NO',
        patientRelationship: '',
        patientName: '',
        patientDateOfBirth: '',
      };
      setForm(nextFormState);
      isValidateForm(false);
    }
    updateErrorState(value, id);
  };

  const patientRelationshipOption = (patientData: any) => {
    const relationshipArrData = patientData
      .map((pat: any) => pat.relationship)
      .filter((rel: any) => rel !== 'Subscriber');
    const filteredRelationshipArrData = [...new Set(relationshipArrData)];
    const patientRelationshipData = filteredRelationshipArrData.map(
      (rel: any) => ({
        value: rel,
        label: rel,
      }),
    );
    return patientRelationshipData;
  };

  const patientNameOption = (patientRelationship: any, patientData: any) => {
    const patientNames = patientData
      .filter((patient: any) => patient.relationship === patientRelationship)
      .map((patient: any) => patient.name);
    const patientNameData = patientNames.map((patient: any) => ({
      value: patient,
      label: patient,
    }));
    return patientNameData;
  };

  useEffect(() => {
    if (form) {
      updateFormData(form);
    }
  }, [form]);

  const onBlurField = (event: any) => {
    updateErrorState(event.target.value, event.target.id);
  };

  const onKeyPressField = (event: any) => {
    updateErrorState(event.target.value, event.target.id);
  };

  return (
    <StackLayout
      css={
        {
          backgroundColor: 'White',
          maxWidth: '800px',
        } as GDSStyleObject
      }
      horizontalAlignment="center"
    >
      <Box
        css={
          {
            display: 'flex',
            flexDirection: 'column',
            padding: '$three $two $two $two',
          } as GDSStyleObject
        }
      >
        <Box
          css={
            {
              display: 'flex',
              flexDirection: 'column',
              padding: '$none $two',
            } as GDSStyleObject
          }
        >
          <HeadingText
            level="1"
            size={{
              '@initial': 'xxl',
              '@mobile': 'xl',
              '@mobileLandscape': 'xl',
              '@tablet': 'xl',
              '@laptop': 'xxl',
              '@desktop': 'xxl',
            }}
          >
            Direct Reimbursement Claim Form
          </HeadingText>
        </Box>
        <Box
          css={
            {
              display: 'flex',
              flexDirection: 'column',
              padding: '$one $two',
              width: '100%',
            } as GDSStyleObject
          }
        >
          <Box
            css={
              {
                display: 'flex',
                flexDirection: 'column',
              } as GDSStyleObject
            }
          >
            <HeadingText
              level="3"
              size={{
                '@initial': 'xl',
                '@mobile': 'lg',
                '@mobileLandscape': 'lg',
                '@tablet': 'xl',
                '@laptop': 'xl',
                '@desktop': 'xl',
              }}
            >
              Step 2: Patient Information
            </HeadingText>
            <ParagraphText
              css={
                {
                  marginTop: '$one',
                  '@mobile': { width: 'auto' },
                  '@desktop': { width: '600px' },
                  '@laptop': { width: '600px' },
                  '@mobileLandscape': { width: '600px' },
                  '@tablet': { width: '600px' },
                } as GDSStyleObject
              }
            >
              Is the policy holder the patient?
            </ParagraphText>
            <FormField
              id="isPolicyHolderPatient"
              label=""
              statusIconLabel="Error"
              inputStatus={isPolicyHolderError ? 'error' : undefined}
              statusMessage={
                isPolicyHolderError ? 'This selection is required.' : ''
              }
            >
              <Fieldset
                css={
                  {
                    display: 'flex',
                    maxWidth: '436px',
                  } as GDSStyleObject
                }
                legend={undefined}
              >
                <Radio
                  id="isPolicyHolderPatient-1"
                  name="isPolicyHolderPatient"
                  checked={
                    (policyHolderRelationship === 'Subscriber' &&
                      planDetailsData.length === 0) ||
                    isPolicyHolderPatient === 'YES'
                  }
                  disabled={
                    policyHolderRelationship !== 'Subscriber' ||
                    (policyHolderRelationship === 'Subscriber' &&
                      planDetailsData.length === 0)
                  }
                  value={IS_POLICY_HOLDER_PATIENT.YES}
                  label={IS_POLICY_HOLDER_PATIENT.YES}
                  onChange={updateIsPolicyHolderPatient}
                />
                <Radio
                  id="isPolicyHolderPatient-2"
                  name="isPolicyHolderPatient"
                  checked={
                    policyHolderRelationship !== 'Subscriber' ||
                    isPolicyHolderPatient === 'NO'
                  }
                  disabled={
                    policyHolderRelationship !== 'Subscriber' ||
                    (policyHolderRelationship === 'Subscriber' &&
                      planDetailsData.length === 0)
                  }
                  value={IS_POLICY_HOLDER_PATIENT.NO}
                  label={IS_POLICY_HOLDER_PATIENT.NO}
                  onChange={updateIsPolicyHolderPatient}
                />
              </Fieldset>
            </FormField>
          </Box>
          {(policyHolderRelationship !== 'Subscriber' ||
            isPolicyHolderPatient === 'NO') && (
            <Box>
              <Box
                css={
                  {
                    display: 'flex',
                    flexDirection: 'column',
                    padding: '$one $none',
                  } as GDSStyleObject
                }
              >
                <FormField
                  id="patientRelationship"
                  label="Patient's Relationship to Policy Holder"
                  statusIconLabel="Error"
                  inputStatus={errors.patientRelationship ? 'error' : undefined}
                  statusMessage={
                    errors.patientRelationship
                      ? "Patient's relationship to policy holder is required."
                      : ''
                  }
                >
                  {policyHolderRelationship !== 'Subscriber' ? (
                    <TextInput value={form.patientRelationship} disabled />
                  ) : (
                    <Select
                      placeholder="Please Select"
                      options={patientRelationshipOption(planDetailsData)}
                      onChange={onUpdateField}
                      value={form.patientRelationship}
                      onBlur={onBlurField}
                      onKeyPress={onKeyPressField}
                    />
                  )}
                </FormField>
              </Box>
              <Box
                css={
                  {
                    display: 'flex',
                    flexDirection: 'column',
                    padding: '$one $none',
                  } as GDSStyleObject
                }
              >
                <FormField
                  id="patientName"
                  label="Patient Name"
                  statusIconLabel="Error"
                  inputStatus={errors.patientName ? 'error' : undefined}
                  statusMessage={
                    errors.patientName ? "Patient's name is required." : ''
                  }
                >
                  {policyHolderRelationship !== 'Subscriber' ? (
                    <TextInput value={form.patientName} disabled />
                  ) : (
                    <Select
                      placeholder="Please Select"
                      options={patientNameOption(
                        form.patientRelationship,
                        planDetailsData,
                      )}
                      onChange={onUpdateField}
                      value={form.patientName}
                      disabled={policyHolderRelationship !== 'Subscriber'}
                      onBlur={onBlurField}
                      onKeyPress={onKeyPressField}
                    />
                  )}
                </FormField>
              </Box>
              <Box
                css={
                  {
                    display: 'flex',
                    flexDirection: 'column',
                    padding: '$one $none',
                  } as GDSStyleObject
                }
              >
                <FormField
                  id="patientDateOfBirth"
                  label="Date of Birth (MM/DD/YYYY)"
                  statusIconLabel="Error"
                  inputStatus={errors.patientDateOfBirth ? 'error' : undefined}
                  statusMessage={
                    errors.patientDateOfBirth
                      ? "Patient's date of birth is required."
                      : ''
                  }
                >
                  <TextInput disabled value={form.patientDateOfBirth} />
                </FormField>
              </Box>
            </Box>
          )}
        </Box>
      </Box>
    </StackLayout>
  );
}
